import React from "react";

import { ApproveStatus, BesuClaimState, ClaimStatus } from "../../types/claim";
import { DataContext } from "../../types/common";
import { emptyPromise } from "../../utils/common";

const ClaimContext = React.createContext<DataContext<BesuClaimState>>({
    data: {
            referenceId: "",
            projectReferenceId: "",
            status: ClaimStatus.SUBMITTED,
            contractorWallet: "",
            developerWallet: "",
            descriptionRef: "",
            documentCount: 0,
            approverCount: 0,
            invoiceCount: 0,
            commentCount: 0,
            createdAt: "",
            updatedAt: "",
            documents: [
                {
                    documentId: "",
                    documentName: "",
                    documentHashHex: ""
                }
            ],
            approvers: [
                {
                    wallet: "",
                    userHashHex: "",
                    roleName: "",
                    externalRef: "",
                    status: 0,
                    actionTimestamp: ""
                },
            ],
            claimApprovers: [
                {
                    status: ApproveStatus.PENDING,
                    actionTimestamp: "",
                    details: {
                        roleName: "",
                        firstName: "",
                        lastName: "",
                        email: "",
                        userProfileName: ""
                    }
                },
            ],
            invoiceReferenceIds: [],
            contractor: {
                accountName: "",
                userProfileName: "",
                wallet: ""
            },
            developer: {
                accountName: "",
                userProfileName: "",
                wallet: ""
            },
            comments: [],
            commentRecords: [],
    },
    mutate: emptyPromise,
});

export default ClaimContext;
